module.exports = __webpack_public_path__ + "static/img/prize2.4bf57d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/prize2.png
// module id = 9W2n
// module chunks = 1